import { useEffect } from 'react';
import './style.scss';
import { AccountData, ItemType } from 'views/components/atoms/accountData';
import { PageLocation } from 'views/components/atoms/pageLocation';
import { useGetAccountInfo } from './hooks/useGetAccountInfo';
import { useLocation } from 'react-router';
import { checkHeaderPath } from 'views/utils/checkHeaderPath';
import { ShowHeaderType } from 'views/constants/enums/ShowHeaderType';
import { Gauge, getGaugeValue } from 'views/components/atoms/gauge';

export const CenterNav = () => {
  const location = useLocation();

  const getNewVariables = () => {
    return {};
  };

  const { accountInfo, getAccountInfo } = useGetAccountInfo(
    getNewVariables(),
    checkHeaderPath(location.pathname) !== ShowHeaderType.Info,
  );

  useEffect(() => {
    if (checkHeaderPath(location.pathname) !== ShowHeaderType.Info) return;
    if (accountInfo.fetching) return;
    getAccountInfo();
  }, [location]);

  return (
    <div className="centerNav">
      <PageLocation />
      {/* TODO:ログインしていなければ以下非表示 */}
      {checkHeaderPath(location.pathname) === ShowHeaderType.Info ? (
        <div className="accountInfoWrapper">
          <div className={'accountInfo'}>
            {/* 口座番号 */}
            <AccountData
              label="口座番号"
              item={accountInfo.data?.GetAccountInfo?.Account || ''}
              itemType={ItemType.Normal}
            />
            <div className="partition" />

            {/* 預かり金 */}
            <AccountData
              label="預り金"
              item={accountInfo.data?.GetAccountInfo?.DepositAmount || ''}
              itemType={ItemType.Amount}
            />
            <div className="partition" />

            {/* 申込証拠金 */}
            <AccountData
              label="申込証拠金"
              item={accountInfo.data?.GetAccountInfo?.MarginAmount || ''}
              itemType={ItemType.Amount}
            />
            <div className="partition" />

            {/* 最終ログイン日 */}
            <AccountData
              label="最終ログイン日時"
              item={accountInfo.data?.GetAccountInfo?.LastLoginDateTime || ''}
              itemType={ItemType.Date}
            />
          </div>
          <a
            href="https://www.fpgsec.jp/support/faq.html#faq05"
            target="_blank"
            rel="noreferrer"
            className="accountInfoLink"
          >
            受益証券発行信託の残高について
          </a>
        </div>
      ) : checkHeaderPath(location.pathname) === ShowHeaderType.Bar ? (
        <Gauge currentPage={getGaugeValue(location.pathname)} />
      ) : null}
    </div>
  );
};
